import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ProjectCardDocument__paid-status" }

import { PropType } from "vue";
import { Document } from "@/types";
import PaidStatus from "@/components/pages/documents/card/PaidStatus.vue";
import { documentToSlug } from "@/tools/document";
import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectCardDocument',
  props: {
    document: {
        type: Object as PropType<Document>,
        required: true,
    },
},
  setup(__props) {

const props = __props;

const router = useRouter();

const selectDocument = () => {
    const slug = documentToSlug(props.document);
    const prefix = props.document.doctype;
    router.push({ name: "Document", params: { slug, prefix } });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    onClick: selectDocument,
    class: "ProjectCardDocument"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(PaidStatus, {
        document: __props.document,
        size: 12
      }, null, 8, ["document"])
    ])
  ]))
}
}

})